// Constants
const LOCAL_HOST = 'http://localhost:8080';
const CHUNK_ANALYTICS_RESULTS = 30;
const TOP_BAR_ELEMENT_ID = 'top-bar';
const PRODUCT_PAGE_SIZE = 6000;
const CHUNK_PAGE = 1000;
const TEN_MINUTES = 1000 * 60 * 10;
const RETRY = 3;
const MAX_AREAS_ITEMS_IN_AG_OP = 500;
const MAPBOX_DEFAULT_PADDING = { left: 30, top: 30, bottom: 30, right: 30 };

// Environments
const ENV_CW_COMPONENTS = process.env.VITE_ENV_CW_COMPONENTS;
const VITE_ENV = process.env.VITE_ENV;

// Keys
const NEMADIGITAL_APP_ID = process.env.VITE_NEMADIGITAL_APP_ID ?? '';
const PROTECTOR_APP_ID = process.env.VITE_PROTECTOR_APP_ID;
const VITE_AMPLITUDE_ID = process.env.VITE_AMPLITUDE_ID;
const BALANCE_APP_ID = process.env.VITE_BALANCE_APP_ID;
const PLANTING_APP_ID = process.env.VITE_PLANTING_APP_ID;
const AUTH_SECRET_ID = process.env.VITE_AUTH_SECRET_ID;
const GRIS_API_KEY = process.env.VITE_GRIS_API_KEY;
const ROLLOUT_KEY = process.env.VITE_ROLLOUT_KEY;
const MAPBOX_KEY = process.env.VITE_MAPBOX_KEY;
const CLIENT_ID = process.env.VITE_CLIENT_ID;
const PDF_SHIFT_API_KEY = process.env.VITE_PDF_SHIFT_API_KEY;

// Static Assets
const STATIC_ASSETS_URL = process.env.VITE_STATIC_ASSETS_URL;

// URLs
const CORE_SERVICES_API_URL = process.env.VITE_CORE_SERVICES_API_URL ?? LOCAL_HOST;
const PROTECTOR_API_URL = process.env.VITE_PROTECTOR_API_URL ?? LOCAL_HOST;
const API_REMOTE_SENSING_URL = process.env.VITE_API_REMOTE_SENSING_URL;
const OAUTH_CROPWISE_URL = process.env.VITE_OAUTH_CROPWISE_URL;
const NEMADIGITAL_URL = process.env.VITE_NEMADIGITAL_URL;
const BALANCE_URL = process.env.VITE_BALANCE_URL;
const PLANTING_URL = process.env.VITE_PLANTING_URL;
const CROPWISE_URL = process.env.VITE_CROPWISE_URL;
const CROPWISE_ELEMENTS_MFE_URL = process.env.VITE_CROPWISE_ELEMENTS_MFE_URL;
const AG_OPERATION_MFE_URL = process.env.VITE_AG_OPERATION_MFE_URL;
const PROTECTOR_CROPWISE_API_URL = process.env.VITE_PROTECTOR_API_CROPWISE_URL;
const API_POWER_BI_URL = process.env.VITE_POWER_BI_URL;
// AI Insights Prompts
const MANAGEMENT_OVERVIEW_PERFORMANCE_INDICATORS = process.env.VITE_AI_INSIGHTS_PROMPT_MANAGEMENT_OVERVIEW_PERFORMANCE_INDICATORS;
const MANAGEMENT_OVERVIEW_MONITORING_RESULTS = process.env.VITE_AI_INSIGHTS_PROMPT_MANAGEMENT_OVERVIEW_MONITORING_RESULTS;
const MANAGEMENT_OVERVIEW_PHENOLOGICAL_STAGE = process.env.VITE_AI_INSIGHTS_PROMPT_MANAGEMENT_OVERVIEW_PHENOLOGICAL_STAGE;
const NOTES = process.env.VITE_AI_INSIGHTS_PROMPT_NOTES;
const X_RAY = process.env.VITE_AI_INSIGHTS_PROMPT_X_RAY;
const AI_INSIGHTS_PROMPTS = {
  MANAGEMENT_OVERVIEW_PERFORMANCE_INDICATORS,
  MANAGEMENT_OVERVIEW_MONITORING_RESULTS,
  MANAGEMENT_OVERVIEW_PHENOLOGICAL_STAGE,
  NOTES,
  X_RAY
} as const;

export {
  AG_OPERATION_MFE_URL,
  AI_INSIGHTS_PROMPTS,
  API_POWER_BI_URL,
  API_REMOTE_SENSING_URL,
  AUTH_SECRET_ID,
  BALANCE_APP_ID,
  BALANCE_URL,
  CHUNK_ANALYTICS_RESULTS,
  CHUNK_PAGE,
  CLIENT_ID,
  CORE_SERVICES_API_URL,
  CROPWISE_ELEMENTS_MFE_URL,
  CROPWISE_URL,
  ENV_CW_COMPONENTS,
  GRIS_API_KEY,
  MAPBOX_DEFAULT_PADDING,
  MAPBOX_KEY,
  MAX_AREAS_ITEMS_IN_AG_OP,
  NEMADIGITAL_APP_ID,
  NEMADIGITAL_URL,
  OAUTH_CROPWISE_URL,
  PDF_SHIFT_API_KEY,
  PLANTING_APP_ID,
  PLANTING_URL,
  PRODUCT_PAGE_SIZE,
  PROTECTOR_API_URL,
  PROTECTOR_APP_ID,
  PROTECTOR_CROPWISE_API_URL,
  RETRY,
  ROLLOUT_KEY,
  STATIC_ASSETS_URL,
  TEN_MINUTES,
  TOP_BAR_ELEMENT_ID,
  VITE_AMPLITUDE_ID,
  VITE_ENV
};
